$(function () {
    const $button = $('.js-hamburger');
    const $menu = $('.js-menu-mobile');

    $button.on('click', toggleMenu);
    $menu.on('click', 'a', hideMenu);

    function toggleMenu() {
        $menu.toggleClass('is-active');
    }

    function hideMenu() {
        $menu.removeClass('is-active')
    }
});





//////////////////
// WEBPACK FOOTER
// ./assets/js/mobileMenu.js
// module id = 19
// module chunks = 0